import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as styles from './DeleteButton.css';

export const DeleteButton = ({ onClick }: { onClick: () => void }): JSX.Element => (
  <button type="button" onClick={onClick} className={styles.DeleteButton}>
    <FontAwesomeIcon size="lg" icon={faTrash} />
  </button>
);
